import UmLike from './main'

UmLike.install = function(Vue) {
  Vue.component(UmLike.name, UmLike)
}

export default UmLike
